/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const STATUS_STYLES = {
  success: {
    bg: '#E7F7EF',
    color: '#0CAF60',
  },
  warning: {
    bg: '#FFF4E5',
    color: '#B76E00',
  },
  gray: {
    bg: '#F4F6F8',
    color: '#637381',
  },
  error: {
    bg: '#FFEDEC',
    color: '#E03137',
  },
};

function getStatusStyle(requestStatus) {
  if (
    requestStatus === 'CONFIRMED' ||
    requestStatus === 'COMPLETED' ||
    requestStatus === 'COMPELETED' ||
    requestStatus === 'SOLD' ||
    requestStatus === 'FULFILLED'
  ) {
    return STATUS_STYLES.success;
  }
  if (requestStatus === 'PENDING' || requestStatus === 'UNDER_REVIEW') {
    return STATUS_STYLES.warning;
  }
  if (requestStatus === 'EXPIRED') {
    return STATUS_STYLES.gray;
  }
  if (
    requestStatus === 'CANCELLED' ||
    requestStatus === 'SALE_FAILED' ||
    requestStatus === 'TRANSACTION_FAILED'
  ) {
    return STATUS_STYLES.error;
  }
  return STATUS_STYLES.gray;
}

export default function StatusBadge({ requestStatus, tabValue, minWidth = '120px' }) {
  const { t } = useTranslation();
  const style = getStatusStyle(requestStatus);

  const label =
    requestStatus === 'FULFILLED'
      ? tabValue === 1
        ? t('reversationRequest.FULFILLED_RENT')
        : t('reversationRequest.FULFILLED_SALE')
      : t(`reversationRequest.${requestStatus}`);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 16px',
        backgroundColor: style.bg,
        borderRadius: '8px',
        minWidth,
      }}
    >
      <Typography
        sx={{
          color: style.color,
          fontWeight: 700,
          fontSize: '10px',
          lineHeight: '16px',
        }}
        variant="subtitle2"
        textAlign="center"
        noWrap
      >
        {label}
      </Typography>
    </Box>
  );
}
